import { fetchWithAuth } from './fetchWithAuth';

// 월별 출근부 조회 (명단 + 기록)
export const fetchCareWork = async (work_ym) => {
  return fetchWithAuth(`/care-work?work_ym=${work_ym}`);
};

// 명단 불러오기 (가입중 조합원 중 명단에 없는 사람 추가)
export const loadCareWorkMembers = async (work_ym) => {
  return fetchWithAuth(`/care-work/members/load`, { method: 'POST', body: JSON.stringify({ work_ym }) });
};

// 칸 저장 (모두 비우면 삭제 처리)
export const saveCareWorkCell = async (cell) => {
  return fetchWithAuth(`/care-work/cell`, { method: 'PUT', body: JSON.stringify(cell) });
};

// 비고 저장
export const saveCareWorkRemark = async (work_ym, emp_no, remark) => {
  return fetchWithAuth(`/care-work/members/remark`, { method: 'PUT', body: JSON.stringify({ work_ym, emp_no, remark }) });
};

// 명단에서 제외
export const removeCareWorkMember = async (work_ym, emp_no) => {
  return fetchWithAuth(`/care-work/members/${work_ym}/${encodeURIComponent(emp_no)}`, { method: 'DELETE' });
};
